// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { themr } from "react-css-themr";
import { Page } from "@lifepay/rc-ui-toolkit";
import { withRouter } from "react-router";
import { Redirect } from "react-router-dom";

// ABSOLUTE PATH IMPORTS
import Menu from "../../Menu";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./ActionSelector.m.scss";

@withRouter
@themr("action-selector-page", styles)
export default class ActionSelector extends Component {
  static propTypes = {
    theme: PropTypes.object, // object with css class names
    match: PropTypes.object,
    basePath: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      pageHeader: "Выберите действие",
    };
  }

  setHeader = ({ pageHeader }) => {
    this.setState({ pageHeader });
  };

  render() {
    const { theme, basePath, match } = this.props;
    const { pageHeader } = this.state;
    return match.params.clientId ? (
      <Page header={pageHeader}>
        <div className={classnames(theme.wrapper)}>
          <Menu basePath={`${basePath}`} />
        </div>
      </Page>
    ) : (
      <Redirect to={`${basePath}/search`} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/pages/ActionSelector/ActionSelector.js